import { takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../redux/actionTypes';
import { submitIncomesSaga } from '../sagas/submitIncomesSaga';
import { initIncomesSaga } from '../sagas/initIncomesSaga';
import { propertyObjectsSaga } from '../sagas/propertyObjectsSaga';

export function* NDFL3LightPropertyIncomeSaga() {
  yield takeEvery(actionTypes.INITIALIZE, initIncomesSaga);
  yield takeEvery(actionTypes.SUBMIT, submitIncomesSaga);
  yield takeEvery(actionTypes.PROPERTY_OBJECTS, propertyObjectsSaga);
}
